import { Component, Input, OnInit } from '@angular/core';
import { CustomerAccountService } from '../../../../services/customer-account.service';

@Component({
  selector: 'app-components-specialist-customer-account-group-read-only',
  templateUrl: './customer-account-group-read-only.component.html'
})
export class CustomerAccountGroupReadOnlyComponent implements OnInit {
  @Input() public customer: Boo.Objects.Customer;
  @Input() public customerAccountTypes: number[];
  @Input() public showBoostSiteAccounts?: boolean;

  showDudaSsoUrl: boolean;
  customerAccounts: Boo.Objects.CustomerAccount[];

  constructor(private customerAccountService: CustomerAccountService) { }

  ngOnInit(): void {
    this.refreshCustomerAccounts();
  }

  onCustomerAccountChanged(_: Boo.Objects.CustomerAccount): void {
    this.refreshCustomerAccounts();
  }

  private refreshCustomerAccounts(): void {
    this.customerAccountService
      .getOrCreate(this.customer.CustomerId, this.customerAccountTypes)
      .subscribe(accounts => {
        this.customerAccounts = accounts
          .slice()
          .sort(
            (a, b) =>
              this.customerAccountTypes.indexOf(a.CustomerAccountTypeId) - this.customerAccountTypes.indexOf(b.CustomerAccountTypeId)
          );
      });
  }
}

